import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import Graph from "../../../../components/ui/graph";
import { IREIGraphDataSet } from "../../../../interface/graph";
import {
  sortObjectByNumericKeys,
  formatCurrencyWithDecimal,
  marketValueVsLoanColors,
} from "../../../../utils/commonUtil";
import { IAnalysisSummaryResponse } from "../../../../interface/analysisSummary";

const PreTaxVsPostTax = () => {
  const analysisData: IAnalysisSummaryResponse = useSelector((state) => state.analyser.analysisSummary);
  const equityInProperty: Number[] = [];
  let preTaxData: Number[] = [];
  let postTaxData: Number[] = [];
  const [chartData, setChartData] = useState([] as IREIGraphDataSet[]);
  const [chartOptions, setChartOptions] = useState({});

  const extractData = () => {
    preTaxData = Object.entries(sortObjectByNumericKeys(analysisData.AnalysisCashDeduction)).reduce(
      (acc, [key, value]) => {
        if (key.startsWith("PreTaxCashflowpaYr") && !key.includes("Today")) {
          acc.preTaxData.push(value);
        }
        return acc;
      },
      { preTaxData: [] }
    ).preTaxData;

    postTaxData = Object.entries(sortObjectByNumericKeys(analysisData.AnalysisSummary)).reduce(
      (acc, [key, value]) => {
        if (key.startsWith("PostTaxCashflowPAYr") && !key.includes("Today")) {
          acc.postTaxData.push(value);
        }
        return acc;
      },
      { postTaxData: [] }
    ).postTaxData;
  };

  const formatYAxisTick = useCallback((value: number) => {
    const num = Math.round(Number(value));
    const formatted = "$" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return formatted;
  }, []);

  useEffect(() => {
    extractData();

    const options = {
      maintainAspectRatio: true,
      aspectRatio: 3.8,
      plugins: {
        legend: {
          display: true,
          position: "right",
        },
        tooltip: {
          title: "",
          callbacks: {
            label: (tooltipItem) => {
              const Tooltip = `${tooltipItem.dataset.label} : ${formatCurrencyWithDecimal(
                tooltipItem.dataset.data[tooltipItem.dataIndex]
              )}`;
              return Tooltip;
            },
          },
          multiLine: true,
        },
      },
      scales: {
        y: {
          ticks: {
            callback: formatYAxisTick,
          },
          grid: {
            display: false,
          },
          beginAtZero: true,
        },
        x: {
          grid: {
            display: false,
          },
        },
      },
    };

    const data: IREIGraphDataSet[] = [
      {
        label: "Pre-tax",
        extraData: equityInProperty,
        data: preTaxData,
        borderColor: marketValueVsLoanColors.marketValue,
        backgroundColor: marketValueVsLoanColors.marketValue,
        borderWidth: 3,
        pointRadius: 2,
        fill: false,
        tension: 0.4,
      },
      {
        label: "After-tax",
        extraData: equityInProperty,
        data: postTaxData,
        borderColor: marketValueVsLoanColors.loan,
        backgroundColor: marketValueVsLoanColors.loan,
        borderWidth: 3,
        pointRadius: 2,
        fill: false,
        tension: 0.4,
      },
    ];

    setChartData(data);
    setChartOptions(options);
  }, [analysisData]);

  return (
    <>
      <Graph
        id="ptpt-graph-pretaxvsposttax"
        graphType="line"
        dataSet={chartData}
        labels={["yr1", "yr2", "yr3", "yr4", "yr5", "yr6", "yr7", "yr8", "yr9", "yr10"]}
        customOptions={chartOptions}
      ></Graph>
    </>
  );
};

export default PreTaxVsPostTax;
